export default {
    chainProtocol: [{
        chain: 'bsc',
        protocol: ['UniswapV2', 'UniswapV3', 'UniswapV4', 'PancakeSwapV2', 'PancakeSwapV3', 'PancakeInfCl'],
    }, {
        chain: 'eth',
        protocol: ['UniswapV2', 'UniswapV3', 'UniswapV4', 'PancakeSwapV2', 'PancakeSwapV3'],
    }, {
        chain: 'base',
        protocol: ['UniswapV2', 'UniswapV3', 'UniswapV4', 'PancakeSwapV2', 'PancakeSwapV3', 'PancakeInfCl', 'AerodromeV2', 'AerodromeV3'],
    }, {
        chain: 'arbitrum',
        protocol: ['UniswapV2', 'UniswapV3', 'UniswapV4', 'PancakeSwapV2', 'PancakeSwapV3'],
    }],
}